module.exports = __webpack_public_path__ + "static/media/truck-active.1b5bf111.svg";